function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.12 12.593a1.25 1.25 0 01-.108.123l-.461.461c-.48.48-1.263.483-1.744.001L.861 9.23a1.234 1.234 0 010-1.745l.462-.461a1.234 1.234 0 011.744-.001L5.67 9.628l7.26-7.265a1.234 1.234 0 011.748-.002l.46.462c.482.481.481 1.265-.001 1.748l-8.019 8.022z",
  fill: "currentColor"
})));